export enum ZoomIdType {
  ZOOM_USER_ID = 'ZOOM_USER_ID',
}
